import {
    UserLogin,
    User,
    SearchResult, PortfolioCompany, CompanyOverview, CompanyRanking, EventItem, CompanySie, CompanyDocument, Version,
} from './models';
import user from '@/store/modules/user';
import axios from 'axios';

const successHandler = (response: any) => {
    return response;
};

const errorHandler = (error: any) => {
    console.log('API ERROR:', error.response.status, error.response.data);
    if (error.response.status === 401) {
        user.reset();
        if (error.response.data.URL) {
            window.location = error.response.data.URL;
        }
    }
    return Promise.reject({ error });
};

axios.interceptors.response.use(
    (response: any) => successHandler(response),
    (error: any) => errorHandler(error),
);

axios.defaults.withCredentials = true;

export async function login(userLogin: UserLogin) {
    try {
        await axios.post('/api/login', userLogin);
        // await getUser();
    } catch (error) {
        // TODO
        alert('Misslyckad inloggning, försök igen!');
        console.log(error);
    }
}

export async function logout() {
    try {
        await axios.get('/api/logout');
        // tslint:disable-next-line:no-empty
    } catch (error) {}
}

export async function getVersion(): Promise<Version | null> {
    try {
        return (await axios.get('/api/version')).data;
    } catch (error) {
        return null;
    }
}

export async function getUser(): Promise<User | null> {
    try {
        return (await axios.get('/api/user')).data;
    } catch (error) {
        return null;
    }
}

export async function addCompany(orgNr: string) {
    try {
        return (await axios.put(`/api/user/companies/${orgNr}`)).data;
    } catch (error) {
        return null;
    }
}

export async function getCompanies(version: number): Promise<PortfolioCompany[] | null> {
    try {
        return (await axios.get(`/api/user/${version}/companies`)).data;
    } catch (error) {
        return null;
    }
}

export async function getEvents(version: number): Promise<EventItem[] | null> {
    try {
        return (await axios.get(`/api/user/${version}/events`)).data;
    } catch (error) {
        return null;
    }
}

export async function getOverview(version: number, orgNr: string): Promise<CompanyOverview | undefined> {
    try {
        return (await axios.get(`/api/user/${version}/companies/${orgNr}/overview`)).data;
    } catch (error) {
        return undefined;
    }
}

export async function getRanking(version: number, orgNr: string): Promise<any | undefined> {
    try {
        return (await axios.get(`/api/user/${version}/companies/${orgNr}/ranking`)).data;
    } catch (error) {
        return undefined;
    }
}

export async function getRankingSie(version: number, orgNr: string): Promise<any | undefined> {
    try {
        return (await axios.get(`/api/user/${version}/companies/${orgNr}/ranking/sie`)).data;
    } catch (error) {
        return undefined;
    }
}

export async function getBalance(version: number, orgNr: string): Promise<any | undefined> {
    try {
        return (await axios.get(`/api/user/${version}/companies/${orgNr}/balance`)).data;
    } catch (error) {
        return undefined;
    }
}

export async function getBalanceSie(version: number, orgNr: string): Promise<any | undefined> {
    try {
        return (await axios.get(`/api/user/${version}/companies/${orgNr}/balance/sie`)).data;
    } catch (error) {
        return undefined;
    }
}

export async function getProfitLoss(version: number, orgNr: string): Promise<any | undefined> {
    try {
        return (await axios.get(`/api/user/${version}/companies/${orgNr}/profitloss`)).data;
    } catch (error) {
        return undefined;
    }
}

export async function getProfitLossSie(version: number, orgNr: string): Promise<any | undefined> {
    try {
        return (await axios.get(`/api/user/${version}/companies/${orgNr}/profitloss/sie`)).data;
    } catch (error) {
        return undefined;
    }
}

export async function getValuation(offset: number, version: number, orgNr: string): Promise<any | undefined> {
    try {
        return (await axios.get(`/api/user/${version}/companies/${orgNr}/valuation/${offset}`)).data;
    } catch (error) {
        return undefined;
    }
}

export async function getValuationSie(offset: number, version: number, orgNr: string): Promise<any | undefined> {
    try {
        return (await axios.get(`/api/user/${version}/companies/${orgNr}/valuation/${offset}/sie`)).data;
    } catch (error) {
        return undefined;
    }
}

export async function getSies(version: number, orgNr: string): Promise<CompanySie[] | undefined> {
    try {
        return (await axios.get(`/api/user/${version}/companies/${orgNr}/sie`)).data;
    } catch (error) {
        return undefined;
    }
}

export async function getDocuments(version: number, orgNr: string): Promise<CompanyDocument[] | undefined> {
    try {
        return (await axios.get(`/api/user/${version}/companies/${orgNr}/document`)).data;
    } catch (error) {
        return undefined;
    }
}

export async function getDocument(documentId: string): Promise<any | undefined> {
    try {
        return (await axios.get(`/api/user/document/${documentId}`)).data;
    } catch (error) {
        return undefined;
    }
}

export async function deleteDocument(documentId: string): Promise<any | undefined> {
    try {
        return (await axios.delete(`/api/user/document/${documentId}`)).data;
    } catch (error) {
        return undefined;
    }
}

export async function getDocumentPlain(documentId: string): Promise<any | undefined> {
    try {
        return (await axios.get(`/api/user/documentplain/${documentId}`)).data;
    } catch (error) {
        return undefined;
    }
}

export async function getSie(sieId: string): Promise<any | undefined> {
    try {
        return (await axios.get(`/api/user/sie/${sieId}`)).data;
    } catch (error) {
        return undefined;
    }
}

export async function searchCompanies(phrase: string): Promise<SearchResult | null> {
    try {
        // TODO: handle input
        return (await axios.get(`/api/search/${phrase}`)).data;
    } catch (error) {
        return null;
    }
}

export async function getSNI(): Promise<any | null> {
    try {
        return (await axios.get(`/api/resources/sni`)).data;
    } catch (error) {
        return null;
    }
}

export async function uploadSie(formData: any): Promise<any> {
    return axios.post('/api/user/sie', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
}

export async function updateSie(sie: any): Promise<any> {
    return axios.put('/api/user/sie', sie);
}

export async function addDocument(document: any): Promise<any> {
    return axios.post('/api/user/document', document);
}

export async function updateDocument(document: any): Promise<any> {
    return axios.put('/api/user/document', document);
}

function sleep(ms = 0) {
    return new Promise((r) => setTimeout(r, ms));
}
